const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const listInvoices = async ({ from, to, lavanderiaId, page = 1, limit = 20 } = {}) => {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  if (lavanderiaId) params.set('lavanderiaId', lavanderiaId);
  if (page) params.set('page', String(page));
  if (limit) params.set('limit', String(limit));
  let res = await fetch(`${API_URL}/invoices?${params.toString()}`, {
    method: 'GET',
    headers: { 'Cache-Control': 'no-cache' },
    cache: 'no-store',
  });
  if (res.status === 304) {
    // retry forcing reload
    res = await fetch(`${API_URL}/invoices?${params.toString()}`, {
      method: 'GET',
      headers: { 'Cache-Control': 'no-cache' },
      cache: 'reload',
    });
  }
  if (!res.ok) throw new Error('Error al listar facturas');
  return await res.json();
};

export const getInvoice = async (id) => {
  const res = await fetch(`${API_URL}/invoices/${id}`, { headers: { 'Cache-Control': 'no-cache' }, cache: 'no-store' });
  if (!res.ok) throw new Error('Error al obtener la factura');
  return await res.json();
};

export const deleteInvoice = async (id) => {
  const res = await fetch(`${API_URL}/invoices/${id}`, { method: 'DELETE', headers: { 'Cache-Control': 'no-cache' }, cache: 'no-store' });
  if (!res.ok) throw new Error('Error al eliminar la factura');
  return await res.json();
};

export const saveInvoice = async ({ invoice, meta = {} }) => {
  const payload = {
    ...invoice,
    meta: { ...(invoice?.meta || {}), ...meta },
  };
  const res = await fetch(`${API_URL}/invoices`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Error al guardar la factura');
  return await res.json();
};
